import React from "react";
import { Link } from "react-router-dom";

/**
 * Global footer shown on public pages (Login, Register, Terms, Privacy)
 * and, more subtly, at the bottom of the in-app AppShell. Links to the
 * two legal pages plus a tiny data-accuracy reminder so there's a
 * persistent, discoverable pointer to the policies from everywhere.
 */
export const AppFooter = ({ compact = false }) => {
  const year = new Date().getFullYear();
  return (
    <footer
      className={`border-t bg-muted/30 text-xs text-muted-foreground ${compact ? "py-3" : "py-5"}`}
      data-testid="app-footer"
    >
      <div className="mx-auto max-w-5xl px-5 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <div>&copy; {year} CSE Investor. All rights reserved.</div>
        <nav className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Link to="/terms" className="hover:text-foreground" data-testid="footer-link-terms">Terms</Link>
          <Link to="/privacy" className="hover:text-foreground" data-testid="footer-link-privacy">Privacy</Link>
          <span className="hidden md:inline text-muted-foreground/50">&middot;</span>
          <span className="italic">
            Data may not be current or accurate. Verify from official sources.
          </span>
        </nav>
      </div>
    </footer>
  );
};

export default AppFooter;
